<div class="loading">
	<div class="spinner"></div>
</div>
